import React from 'react';

import { UserCheckRegularIcon } from '../../shared/icons/icons';

import styles from './verified-reviews-message.scss';

export default function VerifiedReviewsMessage() {
  return (
    <>
      <UserCheckRegularIcon className={styles['icon']} /> All reviews are
      verified customer purchases.
    </>
  );
}
